import React from "react";
import styled from "styled-components";
import Heading from "../../atoms/Heading";
import LabelSelector from "../../molecules/LabelSelector";

const Wrap = styled.div`
    margin-top: 30px;
    padding-top: 32px;
    border-top: 1px solid #e6e6e6;
`;

const Header = styled.div`
    margin-bottom: 32px;

    p {
        font-size: 16px;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
    }
`;

const Title = styled(Heading)`
    margin: 0 0 16px 0;
    padding: 0;
    font-size: 24px;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: -0.8px;
    color: var(--color-heading);
`;

const Body = styled.div`
    @media (min-width: 768px) {
        display: flex;
    }
`;

const ExcludesWrap = styled.div`
    p {
        font-size: 16px;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;
    }
    @media (min-width: 768px) {
        width: 100%;
        padding-right: 30px;
    }
`;

const ExcludesGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 0 -4px 22px;

    .label-wrap {
    }

    label {
        display: block;
        align-items: center;
        justify-content: center;
        height: 64px;
        padding: 20px 20px;
        font-size: 16px;
        font-stretch: normal;
        font-style: normal;
        line-height: 20px;
        letter-spacing: normal;
        font-weight: 500;
    }

    @media (min-width: 990px) {
        .label-wrap {
            width: calc(33.33% - 8px);
        }
    }
`;

function DeliveryExclusions(props) {
    const { exclusions, selectedExclusions, dietType, main_title } = props;

    const handleExclusionChange = (e, reference) => {
        props.handleExclusionChange(e, reference);
    };

    const filterExclusions = () => {
        let type = '';
        if (main_title === 'Low-FODMAP Plan' || main_title === 'Gluten-Free Plan' || main_title === 'Carb-Conscious Plan' || main_title === 'GLP-1 Plan' ) {
            type = 'FL-';
        } else if (main_title === 'Care Plan') {
            type = 'CM-';
        } else {
            type = 'MD-';
        }
        return exclusions.filter((item) => item.sku.includes(type));
    };
    const filteredExclusions = filterExclusions();

    return (
        <Wrap>
            <Header>
                <Title>Select Allergies and Preferences </Title>
                {dietType === "Low-FODMAP Plan" && (
                    <p>
                        All of our recipes are prepared using only Low-FODMAP, gluten-free, organic, and non-GMO ingredients. Every ModifyHealth meal is free of gluten, wheat, refined sugars, artificial colors &#38; flavors.
                    </p>
                )}
                {dietType === "Mediterranean Plan" && (
                    <p>
                        All of our Mediterranean recipes are prepared using only gluten-free, organic, and non-GMO ingredients. Every ModifyHealth meal is free of gluten, wheat, refined sugars, artificial colors &#38; flavors.
                    </p>
                )}
                  {dietType === "Diabetes Plan" && (
                    <p>
                        All of our Diabetes-Friendly recipes are prepared using only gluten-free, organic, and non-GMO ingredients. Every ModifyHealth meal is free of gluten, wheat, refined sugars, artificial colors &#38; flavors.
                    </p>
                )}
                  {dietType === "Gluten-Free Plan" && (
                    <p>
                        All of our Gluten-Free recipes are prepared using only gluten-free, organic, and non-GMO ingredients. Every ModifyHealth meal is free of gluten, wheat, refined sugars, artificial colors &#38; flavors.
                    </p>
                )}
                  {dietType === "Heart-Friendly Plan" && (
                    <p>
                        All of our Heart-Friendly recipes are prepared using only gluten-free, organic, and non-GMO ingredients. Every ModifyHealth meal is free of gluten, wheat, refined sugars, artificial colors &#38; flavors.
                    </p>
                )}
                  {dietType === "Carb-Conscious Plan" && (
                    <p>
                        All of our Carb-Conscious recipes are prepared using only gluten-free, organic, and non-GMO ingredients. Every ModifyHealth meal is free of gluten, wheat, refined sugars, artificial colors &#38; flavors.
                    </p>
                )}
                 {dietType === "B2B Plan" && (
                    <p>
                        All of our B2B recipes are prepared using only gluten-free, organic, and non-GMO ingredients. Every ModifyHealth meal is free of gluten, wheat, refined sugars, artificial colors &#38; flavors.
                    </p>
                )}
                 {dietType === "Care Plan" && (
                    <p>
                        All of our Care recipes are prepared using only gluten-free, organic, and non-GMO ingredients. Every ModifyHealth meal is free of gluten, wheat, refined sugars, artificial colors &#38; flavors.
                    </p>
                )}
                 {dietType === "GLP-1 Plan" && (
                    <p>
                        All of our GLP-1 recipes are prepared using only gluten-free, organic, and non-GMO ingredients. Every ModifyHealth meal is free of gluten, wheat, refined sugars, artificial colors &#38; flavors.
                    </p>
                )}
            </Header>
            <Body>
                <ExcludesWrap>
                    <p>
                        <b>
                            Are there any KEY INGREDIENTS you would like us to exclude from your order?
                        </b>
                    </p>
                    <ExcludesGroup>
                        {filteredExclusions.map((exclusion) => {
                            return (
                                <LabelSelector
                                    text={exclusion.name}
                                    key={exclusion.id}
                                    id={exclusion.id}
                                    exclusionChange={
                                        handleExclusionChange
                                    }
                                    selectedExclusions={selectedExclusions}
                                    bigCloseBtn
                                />
                            );
                        })}
                    </ExcludesGroup>
                </ExcludesWrap>
            </Body>
        </Wrap>
    );
}

export default DeliveryExclusions;
